import { UPDATE_PAGINATION } from "@/constants/pagination";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { createToast } from "vercel-toast";
import { CreateBookingApi } from "../../adapters/create-booking";
import { CreateBookingParams } from "../../adapters/create-booking/create-booking.types";
import { GetBookingsApi } from "../../adapters/get-bookings";
import { BookingDetailsFormat } from "../../adapters/get-bookings/get-bookings.types";
import { GetPrivateRoomsBySpaceApi } from "../../adapters/get-privaterooms-by-space";
import { useGetLeagues } from "../../hooks/use-get-leagues";
import { useGetSpaces } from "../use-get-spaces";

export const useBooking = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [activePrivateRoom, setActivePrivateRoom] = useState(false);
  const [bookingData, setBookingData] = useState<BookingDetailsFormat[]>();
  const [privateRooms, setPrivateRooms] = useState<
    { id: number; name: string }[]
  >([]);
  const [activePage, setActivePage] = useState(
    Number(searchParams.get("page")) || 1,
  );
  const { data: leagues } = useGetLeagues();
  const { data: spaces } = useGetSpaces();

  const handleBooking = async (page?: number) => {
    const response = await GetBookingsApi({
      type: 6,
      limit: 10,
      begin_date: "2023-12-25",
      end_date: "2024-03-09",
      offset: page || Number(searchParams.get("page")),
    });

    const bookings_formatted = response.map((item) => {
      const company_name = leagues
        .filter((league) => league.id === item.booking.company_id)
        .map((item) => item.name)[0];
      return {
        ...item,
        booking: {
          ...item.booking,
          company_name,
        },
      };
    });

    setBookingData(bookings_formatted);
  };

  const PopulateBookings = async (page: number) => {
    try {
      await handleBooking(page);

      setSearchParams({ page: String(page) });
    } catch (err) {
      console.log({ err });
    }
    //
  };

  const updateActivePage = (page: number) => {
    setActivePage(page);
  };

  const handleChangePage = async (page: number) => {
    updateActivePage(page);
    PopulateBookings(page);
  };

  const changeActivePage = (update: UPDATE_PAGINATION) => {
    const operation =
      update === UPDATE_PAGINATION.INCREMENT ? activePage + 1 : activePage - 1;
    updateActivePage(operation);
    PopulateBookings(operation);
  };

  const decreasePage = () => {
    changeActivePage(UPDATE_PAGINATION.DECREMENT);
  };

  const increasePage = () => {
    changeActivePage(UPDATE_PAGINATION.INCREMENT);
  };

  async function handleCreateBooking(data: CreateBookingParams) {
    try {
      const { data: dataBooking } = await CreateBookingApi(data);

      console.log({ dataBooking });
    } catch (error) {
      console.error({ error });
    }
  }

  const handleSelectSpace = async (id: number) => {
    const { data: privateRoomsResponse } = await GetPrivateRoomsBySpaceApi({
      space_id: id,
    });

    setActivePrivateRoom(true);
    setPrivateRooms(privateRoomsResponse);

    if (privateRoomsResponse.length === 0) {
      createToast("Não existe espaços privados cadastrados nesses coworking", {
        type: "error",
        timeout: 2000,
      });
    }
  };

  useEffect(() => {
    setSearchParams({ page: String(activePage) });
    handleBooking();
  }, []);

  return {
    leagues,
    bookings: bookingData,
    handleCreateBooking,
    spaces,
    activePrivateRoom,
    handleSelectSpace,
    privateRooms,
    handleChangePage,
    activePage,
    increasePage,
    decreasePage,
  };
};
